var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankNote01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.166V12.5m10-5v3.333m-.833-7.5c2.04 0 3.144.312 3.693.555a.59.59 0 0 1 .216.149c.063.06.178.237.208.32.05.137.05.212.05.362v8.957c0 .757 0 1.136-.114 1.33a.726.726 0 0 1-.443.366c-.213.075-.642-.007-1.5-.172a11.2 11.2 0 0 0-2.11-.2c-2.5 0-5 1.666-8.333 1.666-2.04 0-3.145-.312-3.694-.554-.073-.032-.11-.049-.215-.15a1.22 1.22 0 0 1-.208-.32c-.05-.136-.05-.211-.05-.361V6.324c0-.758 0-1.136.114-1.33a.726.726 0 0 1 .443-.367c.212-.075.641.008 1.5.173.6.115 1.313.2 2.11.2 2.5 0 5-1.667 8.333-1.667zM12.584 10a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNote01);
export default __webpack_public_path__ + "static/media/bankNote01.3b6d2c14dad699e24a6281c3e59c3e86.svg";
export { ForwardRef as ReactComponent };